<template>
  <section class="lineAlarm">
    <commonHeader title="线路告警列表" isMore @checkMore="checkMore" />
    <div class="customTable">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="lineName" label="线路" show-overflow-tooltip />
        <el-table-column prop="deviceName" label="设备名称" show-overflow-tooltip />
        <el-table-column prop="startTime" label="告警时间" show-overflow-tooltip width="160" />
        <el-table-column prop="alarmDesc" label="告警内容" show-overflow-tooltip />
      </el-table>
    </div>
  </section>
</template>

<script>
  import commonHeader from '../commonHeader.vue'
  import { date } from '@/utils'
  export default {
    components: {
      commonHeader
    },
    data() {
      return {
        tableData: [],
        refreshTimer: null
      }
    },
    mounted() {
      this.getInfoData()
      // 每5分钟刷新一次数据
      this.refreshTimer = setInterval(() => {
        this.getInfoData()
      }, 1000 * 60 * 5)
    },
    methods: {
      getInfoData() {
        let dates = date(new Date())
        this.$axiospost('operation/deviceAlarmApi/getAlarmNowPageList', {
          startTime: [dates.YY, dates.MM, dates.DD].join('-') + ' 00:00:00',
          endTime: [dates.YY, dates.MM, dates.DD].join('-') + ' 23:59:59',
          systemMenuFlag: 'gapStickMonitor',
          alarmLevelId: 2,
          pageSize: 99999,
          pageNum: 1
        }).then(res => {
          if (res.data.status == 10000) {
            this.tableData =
              res.data.data.list.length > 0
                ? res.data.data.list.map(item => {
                    return {
                      ...item,
                      lineName:
                        item.deviceTypeName.indexOf('交流导线') > -1 ? '交流线线路' : '直流线线路'
                    }
                  })
                : []
          }
        })
      },
      checkMore() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.$router.push({ name: 'relaAlarm' })
      }
    },
    beforeDestroy() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  }
</script>

<style lang="less" scoped>
  .lineAlarm {
    .customTable {
      margin: 7.41vh 0.19rem 0;
      height: calc(100% - 7.41vh - 0.93vh);

      overflow: auto;

      /deep/ .el-table {
        thead {
          background-image: linear-gradient(0deg, #063b5d 0%, #004f9b 100%),
            linear-gradient(#053a5c, #053a5c);
          background-blend-mode: normal, normal;

          tr,
          th {
            background: transparent;
            color: #fff;
          }

          th {
            padding: 0.93vh 0;
          }
        }

        td {
          padding: 0.93vh 0;
          border-bottom-color: #7694b8;
          color: #fff;
        }

        tbody tr:nth-child(2n) {
          background-color: #142952;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/lineAlarm.vue